var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'השירות הוקפא והתזרים הפסיק להתעדכן.',"text":'כדי שנמשיך לבנות תזרים חודשי ולשלוח עדכונים צריך לעדכן את פרטי התשלום.',"notification-buttons":[
                      {
                        title:'לעדכון פרטי תשלום',
                        variant: 'primary',
                        action: _vm.updatePayment,
                      } ],"icon-type":'danger'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bda5e3e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/notification/notification-types/DormantNotification.vue
// module id = null
// module chunks = 